import React from "react"
import PropTypes from "prop-types"
import theme from "styles/theme"
import BlockHeader from "components/BlockHeader"
import {containerMaxWidth} from "components/Container"
import CrossLinks from "components/Crosslinking"

const Header = ({label = '', title = ''}) => {
    if (!label && !title) {
        return null
    }
    return (
        <div
            css={{
                padding: "70px 0 80px",
                maxWidth: containerMaxWidth,
                margin: "0 auto",
                [theme.tablet]: {
                    maxWidth: 'none',
                    paddingLeft: 16,
                    paddingRight: 16,
                },
            }}
        >
            <BlockHeader label={label} title={title} />
        </div>
    )
}

Header.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
}

const CrosslinksContent = (props) => {
    const {label = '', title = '', ...rest} = props
    return <div
        css={{
            width: '100vw',
            marginTop: '75px',
            marginLeft: '50%',
            transform: 'translateX(-50%)',
        }}
    >
        <div
            css={{
                borderTop: `8px solid ${theme.midBlue}`,
                background: theme.white,
            }}
        >
            <Header label={label} title={title} />
            <CrossLinks {...rest} />
        </div>
    </div>
}

CrosslinksContent.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
}

export default CrosslinksContent
